// IE 2026 09 23 / ODOO-341407 (заказ Игоря): мультиязычный интерфейс — рантайм словаря UI-строк.
//
// Модель (см. анализ в ODOO-341407): английский текст в коде и конфигах — ключ; переводы лежат в
// словарях `messages/<lang>.json` (плоская карта «английский текст → перевод»; контекстный вариант —
// ключ `text|ctx`; множественное число — массив форм [one, few, many]). Подписи, приходящие с бэка
// (title/tooltip элементов вида, меню, кнопки), локализует сам бэк (localize_attrs + словарь
// addons/*/i18n/<lang>.json), фронт переводит только свои строки.
//
// IE 2026 09 26 / ODOO-341407: на каждом шаге — только языки, ВКЛЮЧЁННЫЕ в базе (сегмент I18N-LANGUAGES → fe.i18n.languages, см.
// enabledLanguageIds); выключенный пропускается, en включён всегда.
// Порядок выбора языка: URL ?fe.i18n.lang=uk → localStorage feSettings['fe.i18n.lang'] (выбор в меню
// пользователя / window.i18n.set) → настройка базы fe.i18n.languageDefault (зеркало localStorage) →
// (IE 2026 09 25 / ODOO-341407: бэк отдаёт группу i18n в answer.settings.fe — SETTINGS_FE_GROUPS; зеркало появляется после первого
// ответа, поэтому на первой загрузке язык базы принимает adoptDbDefaultLanguage — один раз на вкладку, перезагрузкой) →
// регион (IE 2026 09 24 / ODOO-341407: часовой пояс Украины или язык браузера с регионом -UA → uk; иначе uk среди языков
// браузера; иначе первый поддерживаемый язык браузера) → 'en'. Язык фиксируется на время жизни страницы (смена = перезагрузка: культура
// wijmo глобальна). Форматы чисел/дат — отдельная настройка fe.i18n.formatsCulture ('uk' по умолчанию —
// как было до правки; 'auto' = по языку интерфейса).
//
// Консоль: window.i18n.get() / .set('uk') / .reset() / .missing() (строки без перевода на этом языке).
//
// IE 2026 09 24 / ODOO-341407 (поручение Игоря: «при переключении языка не перегружался интерфейс фронтенда, только обновлялись
// заголовки, не терялось открытое, включая несохранённые правки»): язык РЕАКТИВЕН — t()/tn()/getLanguage() читают langVersion
// (shallowRef), поэтому шаблоны и computed перерисовываются сами; switchLanguageLive(id) меняет словарь, культуру wijmo, локаль PrimeVue
// и <html lang> без reload и шлёт window-событие 'i18n:changed' (detail.phase 'ui'); подписи бэка перелокализует src/i18n/relocalize.js
// (phase 'attrs'). Флаг fe.i18n.switchWithoutReload (по умолчанию ВКЛ): window.feSettings.set('fe.i18n.switchWithoutReload', false) —
// прежний путь с перезагрузкой страницы. Замеры — window.i18n.stats().lastSwitch и строки [i18n] в консоли.
//
// IE 2026 09 26 / ODOO-341407 (разбор docs/audit-2026-09-04/i18n_first_login_reload_2026-09-26.md, вариант b): на первой загрузке язык базы
// (languageDefault / languages) приходит в ответе workspace_open, а прежняя перезагрузка шла таймером через 1,5 с — за это время стол успевал
// собраться и разослать widget_open, которые перезагрузка обрывала (499 на edge, бэк досчитывал их впустую). Флаг fe.i18n.firstLoadHold
// (по умолчанию ВКЛ; window.i18nSwitch.get() / .set('firstLoadHold', false) / .reset('firstLoadHold'), URL ?fe.i18n.firstLoadHold=false):
// решение принимается синхронно на ответе с настройками базы (firstLoadDecision), и если нужна перезагрузка — стол не строится, перезагрузка
// сразу (reloadNow). Выключен — прежние adoptDbDefaultLanguage / enforceEnabledLanguage с таймером 1500 мс. Замер — window.i18n.stats().firstLoad
// { inFlight, inFlightAtReload, settledMs, sinceSettingsMs, reloaded, flag, trigger, reason, from, to, held, delayMs } (sessionStorage
// 'fe.i18n.firstLoad' переживает перезагрузку) и строка «[i18n] first load: …» в консоли страницы 2
import { shallowRef } from 'vue'
import { debugLog } from '@/utils/debugLog'   // IE 2026 10 02 / ODOO-345042 (заказ Игоря: сообщения в консоли): «[i18n] first load» — только при localStorage webscm.debug = 1
import { primevueLocale } from './primevue'
import { langPendingDecision } from './langPending'   // IE 2026 10 01 / ODOO-341407
import { signalName } from '@/utils/signalNames'   // IE 2026 10 04 / ODOO-5800 (fe-74): слой названий «метрики → сигналы» (выключатель fe.metricChips.signalsV2)
// ранний читатель настроек (копия store.feSettingEarly: код до createApp стор не видит; импорт стора
// отсюда дал бы цикл mainStore ↔ i18n)
function feSettingEarly(key, def_) {
    try {
        const ov = JSON.parse(localStorage.getItem('feSettings') || '{}')
        if (key in ov) return ov[key]
    } catch (e) { /* приватный режим / чужой формат — дефолт */ }
    try {
        let v = JSON.parse(localStorage.getItem('feSettings.db') || '{}')
        for (const part of String(key).replace(/^fe\./, '').split('.')) {
            if (!v || typeof v !== 'object') { v = undefined; break }
            v = v[part]
        }
        if (v !== undefined && v !== null && v !== '') return v
    } catch (e) { /* приватный режим — дефолт */ }
    return def_
}

export const LANGUAGES = [
    { id: 'en', title: 'English' },
    { id: 'uk', title: 'Українська' },
    { id: 'ru', title: 'Русский' },
]
export const LANGUAGE_DEFAULT = 'en'
export const LANGUAGE_IDS = LANGUAGES.map(l => l.id)

// IE 2026 09 26 / ODOO-341407 (Igor 26.09: «по умолчанию все, кроме английского, выключены; включение — в каждой базе»): языки, ВКЛЮЧЁННЫЕ
// в базе, — сегмент I18N-LANGUAGES бэка (common_modules/i18n_languages.py) приходит в answer.settings.fe.i18n.languages (зеркало
// feSettings.db; локальный override — window.feSettings.set('fe.i18n.languages', ['en', 'uk'])). Меню Language и цепочка выбора языка
// страницы — только по включённым; en — базовый язык, включён всегда. Списка нет (старый бэк: прод Bio на коде 06.09, FADO до пересборки
// образа; служебная база ядра) — все языки, как до сегмента.
export function enabledLanguageIds() {
    const v = feSettingEarly('fe.i18n.languages', null)
    let ids = null
    if (Array.isArray(v)) ids = v
    else if (typeof v === 'string' && v.trim()) ids = v.split(/[\s,;]+/)
    if (!ids) return LANGUAGE_IDS.slice()
    const out = [LANGUAGE_DEFAULT]
    for (const x of ids) {
        const id = String(x || '').trim().toLowerCase()
        if (LANGUAGE_IDS.includes(id) && !out.includes(id)) out.push(id)
    }
    return out
}
export function isLanguageEnabled(id) { return enabledLanguageIds().includes(id) }
// [{id, title}] включённых языков в порядке базы (en первым) — пункты меню Language, строки карточки Translations
export function enabledLanguages() {
    return enabledLanguageIds().map(id => LANGUAGES.find(l => l.id === id)).filter(Boolean)
}
const LOCALES = { en: 'en-US', uk: 'uk-UA', ru: 'ru-RU' }
const OVERRIDE_KEY = 'fe.i18n.lang'

let _lang = LANGUAGE_DEFAULT
let _urlOverride = false
let _dict = new Map()
let _plural = null
let _formats = 'uk'
const _missing = new Set()
const stats = { hits: 0, misses: 0 }
// IE 2026 09 24 / ODOO-341407: реактивная версия языка — растёт при каждом переключении (и после перелокализации подписей бэка)
export const langVersion = shallowRef(0)
let _prevLang = ''            // язык до последнего переключения (обратная карта словаря — retranslate)
let _prevDict = new Map()
let _prevRev = null
let _pvLocale = null          // реактивный объект локали PrimeVue ($primevue.config.locale) и его английский снимок
let _pvLocaleEn = null
let _lastSwitch = null        // замеры последнего переключения (window.i18n.stats().lastSwitch)
export function switchWithoutReload() { return feSettingEarly('fe.i18n.switchWithoutReload', true) !== false }

function _urlLang() {
    try {
        const qs = [location.search || '']
        const h = location.hash || ''
        if (h.includes('?')) qs.push('?' + h.slice(h.indexOf('?') + 1))
        for (const q of qs) {
            const v = new URLSearchParams(q).get(OVERRIDE_KEY)
            if (v && isLanguageEnabled(v)) return v   // IE 2026 09 26 / ODOO-341407: выключенный в базе язык и по URL не включается
        }
    } catch (e) { /* нечитаемый URL */ }
    return ''
}

// IE 2026 09 24 / ODOO-341407 (поручение Игоря: «у всех по умолчанию открывается русский; ожидал английский как раньше либо язык из
// региональных настроек — мы в Украине, ожидал украинский»): язык по РЕГИОНУ, а не по первому языку браузера — у пользователей в
// Украине браузер часто отдаёт ru первым. Украина = часовой пояс Europe/Kyiv (Kiev, Zaporozhye, Uzhgorod, Simferopol) или любой язык
// браузера с регионом -UA → 'uk' даже при русском браузере; иначе 'uk', если он есть среди языков браузера; иначе первый
// поддерживаемый язык браузера (ru / en); иначе '' (→ 'en'). Порядок в detectLanguage не меняется: URL → выбор в меню → настройка базы → регион → 'en'
const UA_TIMEZONES = ['europe/kyiv', 'europe/kiev', 'europe/zaporozhye', 'europe/uzhgorod', 'europe/simferopol']
// IE 2026 09 26 / ODOO-341407: регион языка — из базы (answer.settings.fe.i18n.regions: {lang: {timezones, locales}} включённых языков, поля
// doc.regions записей сегмента I18N-LANGUAGES), без него — встроенное правило «Украина → uk»; locales: '-UA' — регион браузера, 'uk' — язык
function _regions() {
    const v = feSettingEarly('fe.i18n.regions', null)
    const low = (a) => (Array.isArray(a) ? a : String(a || '').split(/[\s,;]+/)).map(x => String(x || '').trim().toLowerCase()).filter(Boolean)
    if (v && typeof v === 'object' && !Array.isArray(v)) {
        const out = {}
        for (const [id, r] of Object.entries(v)) if (LANGUAGE_IDS.includes(id) && r && typeof r === 'object') out[id] = { tz: low(r.timezones), loc: low(r.locales) }
        return out
    }
    if (feSettingEarly('fe.i18n.languages', null)) return {}   // список языков базы пришёл без регионов — регионы в базе сняты
    return { uk: { tz: UA_TIMEZONES, loc: ['-ua'] } }
}
function _localeMatch(l, p) { return p.startsWith('-') ? l.endsWith(p) : (l === p || l.startsWith(p + '-')) }
function _regionalLang() {
    let langs = []
    try { langs = (navigator.languages || [navigator.language || '']).map(l => String(l || '').toLowerCase()) } catch (e) { /* без navigator */ }
    let tz = ''
    try { tz = String(Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase() } catch (e) { /* без Intl / часового пояса */ }
    const enabled = enabledLanguageIds()   // IE 2026 09 26 / ODOO-341407: только включённые в базе языки
    for (const [id, r] of Object.entries(_regions())) {
        if (enabled.includes(id) && (r.tz.includes(tz) || langs.some(l => r.loc.some(p => _localeMatch(l, p))))) return id
    }
    if (enabled.includes('uk') && langs.some(l => l.slice(0, 2) === 'uk')) return 'uk'
    for (const l of langs) {
        const id = l.slice(0, 2)
        if (enabled.includes(id)) return id
    }
    return ''
}

// IE 2026 09 25 / ODOO-341407: выбор пользователя — ТОЛЬКО локальный ключ feSettings['fe.i18n.lang'] (меню / window.i18n.set / принятый
// явный язык USER). Зеркало настроек базы сюда не смешиваем: с группой i18n в answer.settings ключ fe.i18n.lang базы иначе считался бы
// выбором пользователя; язык базы — только fe.i18n.languageDefault (локальный override feSettings сильнее зеркала)
// IE 2026 09 26 / ODOO-341407: выбранный, но выключенный в базе язык — как будто выбора нет (дальше по цепочке: язык базы → регион → en);
// сам выбор в localStorage не стирается — язык включат снова, и он вернётся
function _userSelection() {
    try {
        const v = JSON.parse(localStorage.getItem('feSettings') || '{}')[OVERRIDE_KEY]
        return isLanguageEnabled(v) ? v : ''
    } catch (e) { return '' }   // приватный режим — выбора нет
}
function _dbDefaultLang() {
    const v = feSettingEarly('fe.i18n.languageDefault', '')
    return isLanguageEnabled(v) ? v : ''   // IE 2026 09 26 / ODOO-341407: только включённый (бэк и сам подменяет выключенный на en)
}

export function detectLanguage() {
    const fromUrl = _urlLang()
    if (fromUrl) { _urlOverride = true; return fromUrl }
    const saved = _userSelection()          // выбор пользователя (меню) — IE 2026 09 25 / ODOO-341407: только локальный, не зеркало базы
    if (saved) return saved
    const dbDefault = _dbDefaultLang()      // настройка базы fe.i18n.languageDefault
    if (dbDefault) return dbDefault
    return _regionalLang() || LANGUAGE_DEFAULT   // IE 2026 09 24 / ODOO-341407: регион (часовой пояс / -UA) вместо первого языка браузера
}

export function getLanguage() { void langVersion.value; return _lang }   // IE 2026 09 24 / ODOO-341407: реактивно (computed / render перечитывают язык)
export function isUrlOverride() { return _urlOverride }
// BCP-47 локаль для Intl.* (форматы чисел/дат) — по настройке форматов, не по языку интерфейса
export function getFormatsCulture() { void langVersion.value; return _formats }
export function getLocale() { void langVersion.value; return LOCALES[_formats] || LOCALES[_lang] || 'en-US' }
// IE 2026 09 24 / ODOO-341407 (второй обход dev02: месяцы на осях чартов «January / July» под uk): BCP-47 локаль ЯЗЫКА ИНТЕРФЕЙСА — для
// названий месяцев и прочего текста Intl.* (как подписи бэка в данных DL2); форматы чисел/дат — getLocale() (настройка форматов)
export function getUiLocale() { void langVersion.value; return LOCALES[_lang] || 'en-US' }

// текущая настройка форматов: 'uk' (как было: культура wijmo uk у всех) | 'ru' | 'en' | 'auto' (= язык интерфейса)
function _formatsCulture(lang) {
    const v = String(feSettingEarly('fe.i18n.formatsCulture', 'uk') || 'uk')
    if (v === 'auto') return lang
    return LANGUAGE_IDS.includes(v) ? v : 'uk'
}

async function _loadMessages(lang) {
    if (lang === LANGUAGE_DEFAULT) return new Map()
    let m = null
    if (lang === 'uk') m = await import(/* webpackChunkName: "i18n-uk" */ './messages/uk.json')
    else if (lang === 'ru') m = await import(/* webpackChunkName: "i18n-ru" */ './messages/ru.json')
    const obj = (m && (m.default || m)) || {}
    return new Map(Object.entries(obj))
}

// культуры wijmo: строки контролов (фильтр грида, FlexSheet, olap) — по языку интерфейса,
// форматы Globalize (числа/даты) — по настройке форматов. Файлы культур подменяют
// wijmo.culture целиком, поэтому Globalize форматной культуры сохраняем и возвращаем.
async function _loadCulture(id) {
    if (id === 'uk') await import(/* webpackChunkName: "wj-culture-uk" */ '@mescius/wijmo.cultures/wijmo.culture.uk')
    else if (id === 'ru') await import(/* webpackChunkName: "wj-culture-ru" */ '@mescius/wijmo.cultures/wijmo.culture.ru')
    else if (id === 'en') await import(/* webpackChunkName: "wj-culture-en" */ '@mescius/wijmo.cultures/wijmo.culture.en')
}
// IE 2026 09 24 / ODOO-341407 (смена языка без reload): файл культуры применяет себя при ПЕРВОМ импорте (модуль исполняется один раз;
// повторный import из кэша ничего не меняет — проба dev02: после ru → en строки wijmo оставались русскими). Объект культуры запоминаем
// при первом импорте (_cultureObjs) и дальше применяем сами через wijmo._updateCulture; культура форматов — Globalize другой культуры
// на КОПИИ объекта (сами объекты культур не мутируются; запись реестра wijmo _loadedCultures возвращается исходной)
const _cultureObjs = {}
async function _cultureObj(wj, id) {
    if (_cultureObjs[id]) return _cultureObjs[id]
    const before = wj.culture
    await _loadCulture(id)
    const now = wj.culture
    if (now && now !== before) { _cultureObjs[id] = now; return now }
    // модуль уже исполнялся до нас (кэш) — ищем в реестре wijmo по подписи языка
    const reg = wj._loadedCultures || {}
    const probe = { uk: 'Дорівнює', ru: 'Равно', en: 'Equals' }[id]
    for (const c of Object.values(reg)) {
        const eq = c && c.FlexGridFilter && (c.FlexGridFilter.stringOperators || []).find(o => o && o.op === 0)
        if (eq && probe && eq.name === probe) { _cultureObjs[id] = c; return c }
    }
    return (_cultureObjs[id] = now || null)
}
async function _applyCultures(lang, formats) {
    const wj = await import('@mescius/wijmo')
    try {
        const cLang = await _cultureObj(wj, lang)
        if (!cLang) return
        const cFmt = formats !== lang ? (await _cultureObj(wj, formats)) || cLang : cLang
        const merged = Object.assign({}, cLang, { Globalize: cFmt.Globalize || cLang.Globalize })
        if (typeof wj._updateCulture === 'function') {
            wj._updateCulture(merged)
            // _updateCulture регистрирует объект под именем его Globalize — вернуть в реестр исходную культуру форматов
            const name = merged.Globalize && merged.Globalize.name
            if (name && wj._loadedCultures) wj._loadedCultures[name] = cFmt
        } else if (wj.culture) {
            Object.assign(wj.culture, merged)
        }
        try { if (wj.Control && typeof wj.Control.invalidateAll === 'function') wj.Control.invalidateAll() } catch (e) { /* контролов ещё нет */ }
    } catch (e) {
        console.warn('i18n: wijmo culture not applied', e)
    }
}

// IE 2026 09 24 / ODOO-341407 (второй обход dev02: aria-label «Menu» у wj-menu шапки после живого переключения): wijmo Menu берёт
// ariaLabel из культуры при СОЗДАНИИ контрола — после смены культуры переписываем у живых меню страницы
async function _applyMenuAria() {
    if (typeof document === 'undefined') return
    const wj = await import('@mescius/wijmo')
    const label = wj.culture && wj.culture.Menu && wj.culture.Menu.ariaLabels && wj.culture.Menu.ariaLabels.menuButton
    if (!label || !wj.Control) return
    for (const el of document.querySelectorAll('.wj-menu')) {
        try { const c = wj.Control.getControl(el); if (c && 'ariaLabel' in c) c.ariaLabel = label } catch (e) { /* не контрол */ }
    }
}

export async function i18nInit() {
    _lang = detectLanguage()
    _formats = _formatsCulture(_lang)
    try { document.documentElement.lang = _lang } catch (e) { /* SSR/тесты */ }
    try { _plural = new Intl.PluralRules(LOCALES[_lang] || 'en-US') } catch (e) { _plural = null }
    const [dict] = await Promise.all([_loadMessages(_lang), _applyCultures(_lang, _formats)])
    _dict = dict
    _firstLoadSettle()   // IE 2026 09 26 / ODOO-341407: страница 2 перезагрузки первого входа — язык устоялся, дописать замер
    return _lang
}

function _interpolate(text, params) {
    if (!params) return text
    return text.replace(/\{(\w+)\}/g, (m, k) => (params[k] === undefined || params[k] === null) ? m : String(params[k]))
}

function _lookup(text, ctx) {
    let v
    if (ctx) v = _dict.get(`${text}|${ctx}`)
    if (v === undefined) v = _dict.get(text)
    return v
}

function _pluralForm(forms, n) {
    if (!Array.isArray(forms)) return forms
    const cat = _plural ? _plural.select(Number(n) || 0) : (Number(n) === 1 ? 'one' : 'other')
    if (forms.length >= 3) return forms[{ one: 0, few: 1, many: 2, other: 2 }[cat] ?? 2] ?? forms[forms.length - 1]
    if (forms.length === 2) return forms[cat === 'one' ? 0 : 1]
    return forms[0]
}

// t(text, params?, ctx?) — перевод строки интерфейса; нет перевода → английский текст как есть
export function t(text, params, ctx) {
    void langVersion.value   // IE 2026 09 24 / ODOO-341407: зависимость от версии языка — шаблоны/computed перерисуются при переключении
    if (typeof text !== 'string' || !text) return text
    text = signalName(text)   // IE 2026 10 04 / ODOO-5800 (fe-74): «метрики» в смысле сигналов отчёта → «сигналы» — подмена английского ключа до поиска перевода
    if (_lang === LANGUAGE_DEFAULT) return params ? _interpolate(text, params) : text
    let v = _lookup(text, ctx)
    if (v === undefined || v === null || v === '') {
        stats.misses++
        if (_missing.size < 5000) _missing.add(ctx ? `${text}|${ctx}` : text)
        v = text
    } else {
        stats.hits++
        if (Array.isArray(v)) v = _pluralForm(v, params && params.n)
    }
    return params ? _interpolate(v, params) : v
}

// tn(n, one, other, params?) — множественное число: английские формы в коде, в словаре — массив форм
// по ключу `other` (uk/ru: [one, few, many]); {n} подставляется из params или из n
export function tn(n, one, other, params) {
    void langVersion.value   // IE 2026 09 24 / ODOO-341407: реактивно
    one = signalName(one); other = signalName(other)   // IE 2026 10 04 / ODOO-5800 (fe-74)
    const p = Object.assign({ n }, params || {})
    if (_lang !== LANGUAGE_DEFAULT) {
        const v = _lookup(other)
        if (v !== undefined && v !== null && v !== '') {
            stats.hits++
            return _interpolate(_pluralForm(v, n), p)
        }
        stats.misses++
        if (_missing.size < 5000) _missing.add(other)
    }
    return _interpolate(Number(n) === 1 ? one : other, p)
}

function _saveSelection(id) {
    try {
        const ov = JSON.parse(localStorage.getItem('feSettings') || '{}')
        ov[OVERRIDE_KEY] = id
        localStorage.setItem('feSettings', JSON.stringify(ov))
    } catch (e) { /* приватный режим — язык не переживёт перезагрузку */ }
}

// IE 2026 09 24 / ODOO-341407: локаль PrimeVue — регистрация реактивного объекта (main.js) + английский снимок для обратного переключения
export function registerPrimeVue(locale) {
    if (!locale || typeof locale !== 'object') return
    _pvLocale = locale
    try { _pvLocaleEn = JSON.parse(JSON.stringify(locale)) } catch (e) { _pvLocaleEn = null }
    _applyPrimeVue(_lang)
}
function _applyPrimeVue(lang) {
    if (!_pvLocale) return
    const loc = primevueLocale(lang)
    let base = {}
    try { base = _pvLocaleEn ? JSON.parse(JSON.stringify(_pvLocaleEn)) : {} } catch (e) { base = {} }
    Object.assign(_pvLocale, base, loc || {})   // ключи, которых нет в нашей локали, — английские
}

function _emit(phase, detail) {
    try { window.dispatchEvent(new CustomEvent('i18n:changed', { detail: { phase, ...(detail || {}) } })) } catch (e) { /* без window */ }
}
export function emitChanged(phase, detail) { _emit(phase, detail) }
export function bumpLangVersion() { langVersion.value++ }
export function lastSwitch() { return _lastSwitch }

// IE 2026 09 24 / ODOO-341407: переключение языка БЕЗ перезагрузки — словарь фронта, культура wijmo (+ Globalize по настройке форматов),
// локаль PrimeVue, <html lang>, PluralRules; затем langVersion++ (перерисовка всех t()) и событие 'i18n:changed' (phase 'ui').
// Подписи бэка (attrs виджетов, меню, чипсы) — relocalize.js (phase 'attrs'), его вызывает store.set_language.
export async function switchLanguageLive(id) {
    if (!LANGUAGE_IDS.includes(id)) return null
    const t0 = performance.now(), prev = _lang
    _saveSelection(id)
    if (id === prev) return { lang: id, prev, ms: 0, messagesMs: 0, unchanged: true }
    const formats = _formatsCulture(id)
    const td = performance.now()
    const dict = await _loadMessages(id)
    const messagesMs = Math.round(performance.now() - td)
    await _applyCultures(id, formats)
    try { await _applyMenuAria() } catch (e) { /* без wijmo Menu */ }   // IE 2026 09 24 / ODOO-341407
    _prevLang = prev; _prevDict = _dict; _prevRev = null
    _lang = id; _formats = formats; _dict = dict
    try { _plural = new Intl.PluralRules(LOCALES[id] || 'en-US') } catch (e) { _plural = null }
    try { document.documentElement.lang = id } catch (e) { /* SSR/тесты */ }
    _applyPrimeVue(id)
    _missing.clear()
    langVersion.value++
    const info = { lang: id, prev, ms: Math.round(performance.now() - t0), messagesMs, at: Date.now(), reload: false }
    _lastSwitch = info
    _emit('ui', info)
    console.log(`[i18n] ui switched to ${id} in ${info.ms} ms (messages ${messagesMs} ms, dict ${dict.size} keys)`)
    return info
}

// обратная карта словаря ПРЕЖНЕГО языка: перевод → ключ (English / 'text|ctx'); строки, закэшированные data()/props под прежним языком
function _prevReverse() {
    if (_prevRev) return _prevRev
    const rev = new Map()
    for (const [k, v] of _prevDict) {
        const forms = Array.isArray(v) ? v : [v]
        for (const f of forms) if (typeof f === 'string' && f && f !== k && !rev.has(f)) rev.set(f, k)
    }
    return (_prevRev = rev)
}
// retranslate(text): строка, полученная t() под прежним языком (кэш data()/props компонента), → перевод под текущим языком;
// незнакомая строка — как есть. Ключ с контекстом ('Float|layout') под en возвращает текст до '|'
export function retranslate(text) {
    if (typeof text !== 'string' || !text) return text
    let key = text, fromRev = false
    if (_prevLang && _prevLang !== LANGUAGE_DEFAULT) {
        const k = _prevReverse().get(text)
        if (k !== undefined) { key = k; fromRev = true }
    }
    if (fromRev && _lang === LANGUAGE_DEFAULT) { const i = key.indexOf('|'); return i > 0 ? key.slice(0, i) : key }
    return t(key)
}
// retranslateDeep(obj, keys): в глубину по массивам/объектам (attrs) — подписи title/tooltip кэшированных описаний кнопок/вкладок;
// объекты, локализованные бэком (пометка _i18n / бэкап title_en), не трогаем — их ведёт relocalize.js. Возвращает число замен
export function retranslateDeep(obj, keys = ['title', 'tooltip'], depth = 0) {
    if (!obj || typeof obj !== 'object' || depth > 6) return 0
    let n = 0
    if (Array.isArray(obj)) { for (const it of obj) n += retranslateDeep(it, keys, depth + 1); return n }
    if (obj._i18n || obj.title_en !== undefined) return 0
    for (const key of keys) {
        const v = obj[key]
        if (typeof v === 'string' && v && v !== '-') { const w = retranslate(v); if (w !== v) { obj[key] = w; n++ } }
    }
    if (Array.isArray(obj.attrs)) n += retranslateDeep(obj.attrs, keys, depth + 1)
    return n
}

// выбор языка (меню пользователя / консоль): override в localStorage feSettings + перезагрузка (reload:false — переключение вживую)
export function setLanguage(id, { reload = true, beforeReload = null } = {}) {
    if (!isLanguageEnabled(id)) return false   // IE 2026 09 26 / ODOO-341407: выключенный в базе язык не выбирается
    _saveSelection(id)
    if (!reload) { switchLanguageLive(id); return true }   // IE 2026 09 24 / ODOO-341407
    if (reload) {
        let done = false
        const go = () => { if (done) return; done = true; location.reload() }
        try { if (typeof beforeReload === 'function') beforeReload(go) } catch (e) { go() }
        setTimeout(go, 1500)
    }
    return true
}

export function resetLanguage() {
    try {
        const ov = JSON.parse(localStorage.getItem('feSettings') || '{}')
        delete ov[OVERRIDE_KEY]
        localStorage.setItem('feSettings', JSON.stringify(ov))
    } catch (e) { /* приватный режим */ }
}

// после login/check_sessionKey: явный язык из записи пользователя (другое устройство) — принять и перезагрузить один раз
// IE 2026 09 26 / ODOO-341407: opts.hold (fe.i18n.firstLoadHold, store.get_user) — перезагрузку НЕ назначать: выбор сохраняется, возвращается
// решение { reason: 'userLanguage', from, to }; исполняет его store.i18n_firstLoadHold → reloadNow сразу после разбора ответа login /
// check_sessionKey — после возврата OIDC логина (таймер с нулевой задержкой перебил бы уход на /oidc/). Без флага — прежний таймер 1500 мс
export function adoptServerLanguage(serverLang, explicit, { hold = false, trigger = '', pending = '' } = {}) {
    // IE 2026 09 26 / ODOO-341407: явный язык USER, выключенный в этой базе, не принимается (язык USER общий для всех баз пользователя)
    if (!explicit || !serverLang || !isLanguageEnabled(serverLang) || _urlOverride) return false
    if (serverLang === _lang) {
        // IE 2026 09 25 / ODOO-341407: явный язык USER совпал с языком страницы (выбран регионом / базой) — запомнить как выбор этого браузера,
        // иначе на следующей загрузке язык базы (fe.i18n.languageDefault) встал бы выше выбора пользователя до повторного принятия с перезагрузкой
        if (!_userSelection()) _saveSelection(serverLang)
        return false
    }
    // IE 2026 10 01 / ODOO-341407 (после uk→en и F5 язык возвращался к uk): выбор этого браузера, не дошедший до бэка (роль «только чтение» не
    // сохраняет USER / сохранение не удалось), не перебивается устаревшим языком USER — метка pending (langPending.js) снимается подтверждённым сохранением
    if (langPendingDecision(pending, serverLang, _lang) === 'block') return false
    try {
        if (sessionStorage.getItem('fe.i18n.adopted') === serverLang) return false
        sessionStorage.setItem('fe.i18n.adopted', serverLang)
    } catch (e) { return false }
    const d = { reason: 'userLanguage', from: _lang, to: serverLang }   // IE 2026 09 26 / ODOO-341407
    if (hold) { _saveSelection(serverLang); return d }   // IE 2026 09 26 / ODOO-341407: перезагрузка — reloadNow у вызывающего
    _flWrite(_flRecord(d, { trigger, flag: false, delayMs: 1500 }))   // IE 2026 09 26 / ODOO-341407: замер прежнего пути (таймер setLanguage)
    return setLanguage(serverLang, { reload: true })
}

// IE 2026 09 25 / ODOO-341407: язык базы по умолчанию (fe.i18n.languageDefault) приходит в answer.settings логина / check_sessionKey уже ПОСЛЕ
// выбора языка страницы: на первой загрузке в этом браузере (или после смены настройки) зеркала feSettings.db нет / оно старое → язык выбран
// по региону. Принять язык базы один раз на вкладку (sessionStorage) перезагрузкой — только если язык страницы не задан URL, выбором
// пользователя (localStorage) или явным языком USER (explicitServer). Выбор пользователя НЕ записывается: после перезагрузки detectLanguage
// берёт язык базы из свежего зеркала, и следующая смена настройки базы подхватится так же. Выключатель fe.i18n.adoptDbDefault=false
// (window.feSettings.set или настройки базы) — язык базы действует со следующей загрузки страницы, как до правки.
// Зовёт store.settings_apply (первые настройки ответа: login / check_sessionKey / workspace_open после выбора базы); сверка — ОДИН раз за
// загрузку страницы: смена базы внутри страницы язык не перезагружает (её язык по умолчанию возьмёт следующая загрузка из зеркала)
let _dbAdoptChecked = false
// IE 2026 09 26 / ODOO-341407: решение вынесено из adoptDbDefaultLanguage (те же проверки и сторожа, в том же порядке) — его зовут и прежний
// путь с таймером, и синхронное firstLoadDecision. Возвращает { reason: 'dbDefault', from, to } или null
function _decideDbDefault(explicitServer) {
    if (_dbAdoptChecked) return null
    _dbAdoptChecked = true
    if (_urlOverride || explicitServer || _userSelection()) return null
    const on = feSettingEarly('fe.i18n.adoptDbDefault', true)
    if (on === false || on === 'false') return null
    const dbDefault = _dbDefaultLang()
    if (!dbDefault || dbDefault === _lang) return null
    try {
        if (sessionStorage.getItem('fe.i18n.adoptedDb') === dbDefault) return null
        sessionStorage.setItem('fe.i18n.adoptedDb', dbDefault)
    } catch (e) { return null }
    return { reason: 'dbDefault', from: _lang, to: dbDefault }
}
// прежний путь (fe.i18n.firstLoadHold выключен): перезагрузка через 1500 мс, стол тем временем строится.
// IE 2026 09 26 / ODOO-341407: логика — _decideDbDefault; meta { trigger } — только для замера firstLoad (сравнение с флагом)
export function adoptDbDefaultLanguage(explicitServer, meta = {}) {
    const d = _decideDbDefault(explicitServer)   // IE 2026 09 26 / ODOO-341407
    if (!d) return false
    console.log(`[i18n] database default language ${d.to} (page ${d.from}): reload once to apply`)
    _reloadLater(d, 1500, meta)   // IE 2026 09 26 / ODOO-341407: было setTimeout(() => location.reload(), 1500) — тот же таймер + замер
    return true
}

// IE 2026 09 26 / ODOO-341407: язык страницы выключен в базе (список пришёл после выбора языка: первая загрузка после выката, смена базы на
// странице, язык выключили) — один раз на вкладку перезагрузить на язык цепочки (URL → выбор → язык базы → регион → en, только включённые).
// Выбор пользователя не переписывается: язык включат снова — он вернётся. Зовёт store.settings_apply (отложено на такт, раньше
// adoptDbDefaultLanguage); true — перезагрузка назначена
// IE 2026 09 26 / ODOO-341407: решение — _decideEnabled ({ reason: 'enabled', from, to } или null), прежний таймер — enforceEnabledLanguage
function _decideEnabled() {
    if (isLanguageEnabled(_lang)) return null
    const target = detectLanguage()
    if (!target || target === _lang) return null
    try {
        if (sessionStorage.getItem('fe.i18n.adoptedEnabled') === `${_lang}>${target}`) return null
        sessionStorage.setItem('fe.i18n.adoptedEnabled', `${_lang}>${target}`)
    } catch (e) { return null }
    return { reason: 'enabled', from: _lang, to: target }
}
export function enforceEnabledLanguage(meta = {}) {
    const d = _decideEnabled()   // IE 2026 09 26 / ODOO-341407
    if (!d) return false
    console.log(`[i18n] language ${d.from} is not enabled in this database (${enabledLanguageIds().join(', ')}): reload once to ${d.to}`)
    _reloadLater(d, 1500, meta)   // IE 2026 09 26 / ODOO-341407: было setTimeout(() => location.reload(), 1500) — тот же таймер + замер
    return true
}

// ---------------- IE 2026 09 26 / ODOO-341407: fe.i18n.firstLoadHold — решение о языке на первом ответе с настройками базы ----------------
// firstLoadDecision(explicitServer) — синхронно, те же сторожа, что у прежнего пути (раз на загрузку страницы — _dbAdoptChecked, раз на
// вкладку — sessionStorage fe.i18n.adoptedDb / fe.i18n.adoptedEnabled): сначала «язык страницы выключен в базе», затем «язык базы по
// умолчанию». null — язык страницы остаётся. Решение (не null) исполняет reloadNow — вызывающий (store.i18n_firstLoadHold) стол не строит
export function firstLoadDecision(explicitServer) {
    return _decideEnabled() || _decideDbDefault(explicitServer)
}
const FIRST_LOAD_KEY = 'fe.i18n.firstLoad'
let _firstLoad = null   // замер этой страницы (window.i18n.stats().firstLoad)
function _inFlightNow() { try { return window.jQuery ? window.jQuery.active : null } catch (e) { return null } }
function _appStartAt() { try { return Math.round(performance.timeOrigin) } catch (e) { return null } }
function _flWrite(rec) { try { sessionStorage.setItem(FIRST_LOAD_KEY, JSON.stringify(rec)) } catch (e) { /* приватный режим — без замера */ } }
// запись замера: inFlight — запросов jQuery в полёте в момент решения (meta.inFlight — вызывающий уже вычел свой запрос), appStartAt —
// начало загрузки страницы 1 (performance.timeOrigin), settingsAt — приход настроек базы
function _flRecord(d, meta = {}) {
    const now = Date.now()
    const inFlight = meta.inFlight !== undefined && meta.inFlight !== null ? meta.inFlight : _inFlightNow()
    return { reason: d.reason, from: d.from, to: d.to, trigger: meta.trigger || '', flag: !!meta.flag, hold: !!meta.hold, held: !!meta.held,
        delayMs: meta.delayMs ?? null, inFlight, inFlightAtReload: null, appStartAt: _appStartAt(), settingsAt: meta.settingsAt || now, decidedAt: now,
        reloadAt: null, url: meta.url ? String(meta.url).replace(/^[^#]*/, '') : '', reloaded: true }
}
function _reloadLater(d, delayMs, meta = {}) {   // прежний путь: таймер; в момент перезагрузки дописать, сколько запросов оборвётся
    const rec = _flRecord(d, { ...meta, flag: false, hold: false, held: false, delayMs })
    _flWrite(rec)
    setTimeout(() => { rec.reloadAt = Date.now(); rec.inFlightAtReload = _inFlightNow(); _flWrite(rec); location.reload() }, delayMs)
}
// reloadNow(decision, meta { trigger, inFlight, url, held }) — перезагрузка СРАЗУ (fe.i18n.firstLoadHold). url — адрес цели ещё не
// подтверждённой навигации роутера (store.i18n_firstLoadUrl): без него страница 2 открылась бы на прежнем адресе (#/select-database)
export function reloadNow(decision, meta = {}) {
    const rec = _flRecord(decision, { ...meta, flag: true, hold: true, held: meta.held !== false, delayMs: 0 })
    rec.reloadAt = rec.decidedAt
    rec.inFlightAtReload = rec.inFlight
    _flWrite(rec)
    debugLog(`[i18n] first load: ${decision.from} → ${decision.to} (${decision.reason}) after ${rec.trigger || 'settings'}: reload now, the page is not built (in flight ${rec.inFlight})`)
    try { if (meta.url) history.replaceState(null, '', meta.url) } catch (e) { /* адрес не подменён — перезагрузка текущего */ }
    location.reload()
    return true
}
// firstLoadSettled(meta) — решение принято, перезагрузка не нужна: замер этой страницы (первый — остаётся; на странице 2 — уже из i18nInit)
export function firstLoadSettled(meta = {}) {
    if (_firstLoad) return _firstLoad
    const rec = _flRecord({ reason: null, from: _lang, to: _lang }, { ...meta, hold: !!meta.flag })
    rec.reloaded = false
    rec.url = ''
    rec.settledAt = rec.decidedAt
    rec.settledMs = rec.appStartAt ? rec.settledAt - rec.appStartAt : null
    rec.sinceSettingsMs = rec.settledAt - rec.settingsAt
    _firstLoad = rec
    debugLog(`[i18n] first load: ${_lang} kept, no reload (trigger ${rec.trigger || 'settings'}); settled in ${rec.settledMs} ms from the page start`)
    return rec
}
// страница 2 (из i18nInit, словарь загружен): незавершённая запись перезагрузки первого входа — дописать settledAt / settledMs
function _firstLoadSettle() {
    let rec = null
    try { rec = JSON.parse(sessionStorage.getItem(FIRST_LOAD_KEY) || 'null') } catch (e) { rec = null }
    if (!rec || !rec.reloaded || rec.settledAt) return
    const at = rec.reloadAt || rec.decidedAt || 0
    if (!at || Date.now() - at > 120000) return   // старая запись (не эта перезагрузка) — не трогать
    rec.settledAt = Date.now()
    rec.langAfter = _lang
    rec.settledMs = rec.appStartAt ? rec.settledAt - rec.appStartAt : null
    rec.sinceSettingsMs = rec.settingsAt ? rec.settledAt - rec.settingsAt : null
    rec.reloadMs = rec.reloadAt ? rec.settledAt - rec.reloadAt : null
    _flWrite(rec)
    _firstLoad = rec
    debugLog(`[i18n] first load: ${rec.from} → ${rec.to} (${rec.reason}) settled in ${rec.settledMs} ms (${rec.sinceSettingsMs} ms after the database settings); `
        + `${rec.held ? `build held after ${rec.trigger}` : `reload ${rec.delayMs} ms after the settings, build not held`}; in flight at reload: ${rec.inFlightAtReload}`)
}

export function missing() { return Array.from(_missing).sort() }
export function i18nStats() { return { lang: _lang, formats: _formats, dict: _dict.size, ...stats, missing: _missing.size, langVersion: langVersion.value, switchWithoutReload: switchWithoutReload(), lastSwitch: _lastSwitch,
    urlOverride: _urlOverride, selection: _userSelection(), dbDefault: _dbDefaultLang(), enabled: enabledLanguageIds(),
    firstLoad: _firstLoad } }   // IE 2026 09 24 / ODOO-341407: замеры переключения; IE 2026 09 25 / ODOO-341407: источники выбора языка (URL / выбор / язык базы); IE 2026 09 26 / ODOO-341407: включённые в базе языки; IE 2026 09 26 / ODOO-341407: замер первой загрузки (fe.i18n.firstLoadHold)

export default { t, tn, getLanguage, getLocale, setLanguage, resetLanguage, LANGUAGES }
